var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueScreenPlayBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9473,
    cy: 40.2275,
    rx: 39.9649,
    ry: 40,
    fill: "#0051C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9824 54.2275C31.5225 54.2267 31.0707 54.1042 30.6715 53.8722C29.7727 53.3548 29.2139 52.3505 29.2139 51.2602V29.1951C29.2139 28.1017 29.7727 27.1004 30.6715 26.583C31.0802 26.3444 31.5445 26.2217 32.0158 26.2278C32.4872 26.2338 32.9482 26.3683 33.3509 26.6172L51.9162 37.9054C52.3031 38.1519 52.6221 38.4941 52.8432 38.9C53.0643 39.3059 53.1803 39.7622 53.1803 40.2261C53.1803 40.69 53.0643 41.1463 52.8432 41.5522C52.6221 41.9581 52.3031 42.3003 51.9162 42.5467L33.3479 53.838C32.9358 54.091 32.4639 54.2257 31.9824 54.2275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueScreenPlayBtnIcon);
export default __webpack_public_path__ + "static/media/queueScreenPlayBtnIcon.ffbf047f551dff64eef4785887d735d1.svg";
export { ForwardRef as ReactComponent };